import { getPortfolioImpactState } from "#/utils/getPortfolioImpactState";

enum ImpactColors {
  Danger = "text-error",
  Error = "text-orange-500",
  Warning = "text-warning",
  Success = "text-success",
}

export type ImpactColor = `${ImpactColors}`;

export const getImpactColor = (value: number): ImpactColor => {
  const impact = getPortfolioImpactState(value);

  if (impact === "danger") return ImpactColors.Danger;
  if (impact === "error") return ImpactColors.Error;
  if (impact === "warning") return ImpactColors.Warning;
  return ImpactColors.Success;
};
